import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class AuthorizationGuard implements CanActivate {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const ok = this.oidcSecurityService.userData$.pipe(
      map((userInfo: any) => {


        const isAuthorized = userInfo && userInfo.userData &&
          userInfo.userData.hasOwnProperty('role') &&
          (userInfo.userData.role.includes('adminpanel_login') || userInfo.userData.role.includes('adminpanel_go'));

        const isAuthorizedPremium = userInfo &&
          userInfo.userData &&
          userInfo.userData.hasOwnProperty('role') &&
          userInfo.userData.role.includes('adminpanel_global_admin');

        console.log('adminpanel_global_admin: ' + isAuthorizedPremium);

        if (!isAuthorized) {
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
          return false;
        }

        return true;
      }),
    );


    return ok;
  }
}
